import $ from 'jquery';



$(()=>{
      $("#tblissue").DataTable();
});